import { apiCall } from "../../../../../_utils";
import { apiUrls } from "../../../../../_constants";

export const sendMealPlanServices={
    getAllSendFoodItems,
    getDailyMealRoaster
}



function getAllSendFoodItems(params){

 return apiCall("GET",apiUrls.food.mealPlan,null,params)
}

function getDailyMealRoaster(id){

    return apiCall("GET",`${apiUrls.food.mealPlan}/${id}/roster`)
   }

